import { useMemo } from 'react'
import MessageCard from '@groovehq/internal-design-system/lib/components/MessageCard/MessageCard'
import {
  text,
  paragraph,
} from '@groovehq/internal-design-system/lib/styles/elements'

export default function useSourceWording(source) {
  return useMemo(
    () => {
      if (source === 'inbox') {
        return {
          drawerTitle: 'Reconnect Gmail',
          title: `Re-authenticate your Gmail ${app.t('mailbox')}.`,
          intro: (
            <>
              <p>
                Occasionally Gmail may require re-authentication if Google has
                changed their permissions or if your Gmail account has updated
                your security settings or changed your password.
              </p>

              <MessageCard type="warning" className="grui mt-11">
                <div css={text.styles.fontMedium}>Heads up</div>
                <p css={paragraph.styles.preflight} className="grui my-5">
                  Groove will reprocess the last 100 emails received and import
                  any missing conversations.
                </p>
              </MessageCard>
            </>
          ),
        }
      }
      return {}
    },
    [source]
  )
}
